import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Tooltip from '../../../../molecules/ToolTip/Tooltop';

const ButtonFinishOrder = ({ disabled, onClick, children, className, importantClasses, tooltip, to }) => {
  return (
    <Tooltip value={tooltip}>
        <Link to={to}>
    <button
      disabled={disabled}
      onClick={onClick}
      className={importantClasses || `${disabled ? 'bg-gray-400' : 'bg-gold2 hover:bg-gold'}  !w-full transition text-white rounded-lg px-4 py-2 ${className}`}>
      {children}
    </button>
    </Link>
    </Tooltip>
  );
};

ButtonFinishOrder.propTypes = {
  children: PropTypes.any,
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default ButtonFinishOrder;
